import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["step", "form"];

  toggle() {
    let currentTarget = this.stepTargets.filter((t) => !t.classList.contains('hidden'))[0];
    currentTarget.classList.toggle('hidden');

    let nextStep = currentTarget.dataset.nextStep;
    let el = document.getElementById(nextStep);
    el.classList.toggle('hidden');
  }

  setMessageError(message) {
    const container = document.getElementById('error-container');
    const item = document.getElementById('error-list-item');
    item.innerHTML = message;
    item.classList.remove('hidden');
    container.classList.remove('hidden');
  }

  clearMessageError() {
    const container = document.getElementById('error-container');
    const item = document.getElementById('error-list-item');
    item.innerHTML = '';
    item.classList.add('hidden');
    container.classList.add('hidden');
  }

  stepOne() {
    const nameField = document.getElementById('user_name');

    this.clearMessageError();
    if (!nameField.value) {
      this.setMessageError("Por favor, insira seu nome.")
    } else {
      this.toggle();
      this.updateNavigation("element", "step-2", "step-1");
    }
  }

  stepTwo() {
    const emailField = document.getElementById('user_email');

    this.clearMessageError();
    if (!emailField.value) {
      this.setMessageError("Por favor, insira seu e-mail.")
    } else if (!this.emailValidation(emailField.value)) {
      this.setMessageError("Por favor, insira um e-mail válido.")
    } else {
      this.toggle();
      this.updateNavigation("element", "step-3", "step-2");
    }
  }

  emailValidation(element) {
    var filter = /^[a-zA-Z0-9\-_]+(\.[a-zA-Z0-9\-_]+)*@[a-z0-9]+(\-[a-z0-9]+)*(\.[a-z0-9]+(\-[a-z0-9]+)*)*\.[a-z]{2,4}$/;
    if (filter.test(element)) {
      return true;
    }
    else {
      return false;
    }
  }

  updateNavigation(type, current, to) {
    const nav = document.getElementById('nav-authentication');
    nav.dataset.previousType = type;
    nav.dataset.current = current;
    nav.dataset.previousTo = to;
  }
}